<template>
  <div class="reviews-page reviews-detail" v-if="review">
    <article>
      <header class="reviews-detail__header">
        <div class="container">
          <router-link :to="{ name: 'reviews' }" class="back-link">← {{ $t('reviews.backToList') }}</router-link>
          <span class="reviews-detail__source">{{ review.sourceBlog }} · {{ review.sourceDate }}</span>
          <h1>{{ content.title }}</h1>
          <p class="lead">{{ content.intro }}</p>
        </div>
      </header>
      <div class="reviews-detail__hero">
        <img
          :src="review.hero"
          :alt="content.title"
          referrerpolicy="no-referrer"
          @error="onHeroError"
        >
      </div>
      <div class="container reviews-detail__body">
        <section v-for="(s, i) in content.sections" :key="i" class="reviews-detail__section">
          <h2>{{ s.heading }}</h2>
          <p>{{ s.body }}</p>
        </section>
        <blockquote class="reviews-detail__quote">
          <p>{{ pullQuote }}</p>
          <cite>
            — {{ review.sourceAuthor }},
            <a :href="review.sourceUrl" rel="nofollow noopener" target="_blank">{{ review.sourceBlog }}</a>
          </cite>
        </blockquote>
        <p class="reviews-detail__attribution">
          {{ $t('reviews.attributionPrefix') }}
          <a :href="review.sourceUrl" rel="nofollow noopener" target="_blank">{{ $t('reviews.readOriginal') }} →</a>
        </p>
      </div>
    </article>
    <div class="reviews-cta">
      <div class="container">
        <h3>{{ $t('reviews.ctaHeading') }}</h3>
        <router-link :to="{ name: 'products', query: { type: 'diarybook' } }" class="btn gradient">
          {{ $t('reviews.ctaButton') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { buildMeta } from 'src/utils/seo'
import { getReview } from './data.js'

export default {
  name: 'review-detail',
  metaInfo () {
    if (!this.review) {
      return buildMeta({ title: this.$t('reviews.indexMetaTitle'), path: '/reviews' })
    }
    return buildMeta({
      title: this.content.title,
      description: this.content.teaser || this.content.intro,
      path: `/reviews/${this.review.slug}`,
      image: this.review.hero,
      type: 'article'
    })
  },
  computed: {
    ...mapGetters(['language']),
    review () {
      return getReview(this.$route.params.slug)
    },
    content () {
      if (!this.review) return {}
      return this.review.locales[this.language] || this.review.locales['zh-tw'] || this.review.locales.en
    },
    pullQuote () {
      if (!this.review) return ''
      return this.review.pullQuote[this.language] || this.review.pullQuote['zh-tw'] || this.review.pullQuote.en
    }
  },
  created () {
    if (!this.review) {
      this.$router.replace({ name: 'not-found' })
    }
  },
  methods: {
    onHeroError (e) {
      const fb = this.review && this.review.heroFallback
      if (fb && e.target.src !== fb) {
        e.target.src = fb
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/views/Reviews.scss';
</style>
